export const isEmptyValue = ({
  isMultiple,
  value,
}: {
  value: unknown;
  isMultiple: boolean;
}) => {
  return (
    value === "" ||
    value === null ||
    (isMultiple && Array.isArray(value) && value.length < 1)
  );
};
